import { create } from 'zustand';

type CoopRunPhase = 'idle' | 'loading' | 'running';

interface CoopRunState {
  phase: CoopRunPhase;
  setPhase: (phase: CoopRunPhase) => void;
}

export const useCoopRunStore = create<CoopRunState>((set) => ({
  phase: 'idle',
  setPhase: (phase) => set({ phase }),
}));
